import { Component } from '@angular/core';
import { AttributeList } from '../../../../components/admin-dashboard-component/attributes/attribute-list/attribute-list';

@Component({
  selector: 'app-view-all-attributes',
  imports: [AttributeList],
  templateUrl: './view-all-attributes.html',
  styleUrl: './view-all-attributes.scss',
})
export class ViewAllAttributes {}
